import { testSaga } from "redux-saga-test-plan"
import { sendQuery } from "api/graphql"
import { graphqlSaga } from "../apiWrapper"

const ACCOUNT = "test-account"
const QUERY = "query { test }"
const VARIABLES = { id: 1 }
const MOCK_RESULT = { data: { test: true } }

function makeAction(overrides = {}) {
  const resolve = jest.fn()
  const reject = jest.fn()
  return {
    account: ACCOUNT,
    query: QUERY,
    variables: VARIABLES,
    resolve,
    reject,
    abortSignal: undefined,
    ...overrides,
  }
}

describe("graphqlSaga", () => {
  describe("success", () => {
    it("should call sendQuery with beta=false and abortSignal, then resolve", () => {
      const signal = new AbortController().signal
      const action = makeAction({ abortSignal: signal })

      testSaga(graphqlSaga, action)
        .next()
        .call(sendQuery, QUERY, VARIABLES, ACCOUNT, false, signal)
        .next(MOCK_RESULT)
        .call(action.resolve, MOCK_RESULT)
        .next()
        .isDone()
    })

    it("should pass undefined signal when no abortSignal is provided", () => {
      const action = makeAction()

      testSaga(graphqlSaga, action)
        .next()
        .call(sendQuery, QUERY, VARIABLES, ACCOUNT, false, undefined)
        .next(MOCK_RESULT)
        .call(action.resolve, MOCK_RESULT)
        .next()
        .isDone()
    })
  })

  describe("AbortError handling", () => {
    it("should call reject with AbortError so the queryFn Promise settles and TanStack can clean up", () => {
      const abortError = new DOMException("The operation was aborted", "AbortError")
      const action = makeAction({ abortSignal: new AbortController().signal })

      testSaga(graphqlSaga, action)
        .next()
        .call(sendQuery, QUERY, VARIABLES, ACCOUNT, false, action.abortSignal)
        .throw(abortError)
        .call(action.reject, abortError)
        .next()
        .isDone()
    })
  })

  describe("error handling", () => {
    it("should call reject with non-abort errors", () => {
      const networkError = new Error("Network failure")
      const action = makeAction()

      testSaga(graphqlSaga, action)
        .next()
        .call(sendQuery, QUERY, VARIABLES, ACCOUNT, false, undefined)
        .throw(networkError)
        .call(action.reject, networkError)
        .next()
        .isDone()
    })

    it.each([
      ["TypeError", new TypeError("Failed to fetch")],
      ["TechnicalError with name Error", Object.assign(new Error("Server error"), { name: "Error" })],
    ])("should call reject for %s", (_, error) => {
      const action = makeAction()

      testSaga(graphqlSaga, action)
        .next()
        .call(sendQuery, QUERY, VARIABLES, ACCOUNT, false, undefined)
        .throw(error)
        .call(action.reject, error)
        .next()
        .isDone()
    })
  })
})
